export enum ClientGroupCode {
  ABElectrolux = '00168',
  AmicaMatrix = '00010',
  Beko = '00030',
  GlenDimplex = '00099',
  Haier = '00120',
  Husqvarna = '00086',
  KohlerMira = '00187',
  LG = '00157',
  Sainsburys = '00045',
  Whirlpool = '00138',
}
